(function () {
  'use strict';

  const overlay  = document.getElementById('qaOverlay');
  const sheet    = document.getElementById('qaSheet');
  const sizesEl  = document.getElementById('qaSizes');
  const titleEl  = document.getElementById('qaTitle');
  const feedback = document.getElementById('qaFeedback');

  if (!overlay || !sheet || !sizesEl || !titleEl || !feedback) return;

  // ── Abrir / cerrar ────────────────────────────────────────────
  function openSheet(variants, productTitle) {
    titleEl.textContent  = productTitle || '';
    sizesEl.innerHTML    = '';
    feedback.textContent = '';
    feedback.className   = 'qa-feedback';

    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.className   = 'qa-size' + (v.available ? '' : ' qa-size--oos');
      btn.textContent = v.title;
      if (v.available) {
        btn.addEventListener('click', function () { addToCart(v.id); });
      }
      sizesEl.appendChild(btn);
    });

    overlay.classList.add('active');
    sheet.classList.add('active');
    document.body.classList.add('qa-sheet-open');
    document.body.style.overflow = 'hidden';
    hideBottomRightFixed();
  }

  function closeSheet() {
    overlay.classList.remove('active');
    sheet.classList.remove('active');
    document.body.classList.remove('qa-sheet-open');
    document.body.style.overflow = '';
    restoreBottomRightFixed();
  }

  // ── Subir elementos fixed de esquina inferior derecha ───────────
  var hiddenEls = [];

  function hideBottomRightFixed() {
    hiddenEls = [];
    var W = window.innerWidth;
    var H = window.innerHeight;

    requestAnimationFrame(function () {
      var sheetH = sheet.offsetHeight + 16;

      document.querySelectorAll('body *').forEach(function (el) {
        if (el === overlay || el === sheet || overlay.contains(el) || sheet.contains(el)) return;
        if (window.getComputedStyle(el).position !== 'fixed') return;
        var rect = el.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return;
        if (rect.right > W * 0.5 && rect.bottom > H * 0.5 && rect.width < 300 && rect.height < 300) {
          hiddenEls.push({ el: el, prevTransform: el.style.transform });
          el.style.setProperty('transition', 'transform 0.3s ease', 'important');
          el.style.setProperty('transform', 'translateY(-' + sheetH + 'px)', 'important');
        }
      });
    });
  }

  function restoreBottomRightFixed() {
    hiddenEls.forEach(function (item) {
      item.el.style.setProperty('transition', 'transform 0.3s ease', 'important');
      if (item.prevTransform) {
        item.el.style.setProperty('transform', item.prevTransform, 'important');
      } else {
        item.el.style.removeProperty('transform');
      }
      setTimeout(function () { item.el.style.removeProperty('transition'); }, 300);
    });
    hiddenEls = [];
  }

  overlay.addEventListener('click', closeSheet);

  // Cerrar con swipe hacia abajo en móvil
  var startY = 0;
  sheet.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
  sheet.addEventListener('touchend', function (e) {
    if (e.changedTouches[0].clientY - startY > 60) closeSheet();
  });

  // ── Añadir al carrito ─────────────────────────────────────────
  function addToCart(variantId) {
    feedback.textContent = 'Añadiendo…';
    feedback.className   = 'qa-feedback';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) throw new Error(data.description || 'Error al añadir');
      feedback.textContent = '✓ Añadido al carrito';
      feedback.className   = 'qa-feedback ok';
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      // Añadido desde el menú móvil: se cierra el menú (como su botón) para que el carrito quede delante
      if (document.body.classList.contains('reveal-mobile-nav')) {
        document.body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed');
        setTimeout(function () { document.body.classList.remove('enable-mobile-nav-transition'); }, 750);
      }
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      setTimeout(closeSheet, 1000);
    })
    .catch(function (err) {
      feedback.textContent = err.message || 'Error al añadir';
      feedback.className   = 'qa-feedback err';
    });
  }

  // ── Inyectar botones "+" en las tarjetas de producto ─────────
  function injectButtons() {
    // También las tarjetas recortadas del escaparate MOST WANTED del menú móvil (div, no product-block)
    document.querySelectorAll('product-block[data-qa-variants], .product-block--cutout[data-qa-variants]').forEach(function (card) {
      if (card.querySelector('.quick-add-trigger')) return;

      var imageWrap = card.querySelector('.image-cont');
      if (!imageWrap) return;

      var variants = [];
      try {
        variants = JSON.parse(card.dataset.qaVariants || '[]');
      } catch (e) { return; }

      if (!variants.length) return;

      var productTitle = card.dataset.qaTitle || '';

      var btn = document.createElement('button');
      btn.className = 'quick-add-trigger';
      btn.setAttribute('aria-label', 'Añadir al carrito rápido');
      btn.textContent = '+';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSheet(variants, productTitle);
      });

      imageWrap.appendChild(btn);
    });
  }

  // ── Botones "+" en galería carousel ──────────────────────────
  function injectGalleryButtons() {
    document.querySelectorAll('.carousel-product-card__button[data-product-url]').forEach(function (btn) {
      if (btn.dataset.qaInitialized) return;
      btn.dataset.qaInitialized = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var url = btn.dataset.productUrl;
        var path;
        try { path = new URL(url).pathname; } catch (_) { path = url.split('?')[0]; }

        fetch(path + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var variants = (product.variants || []).map(function (v) {
              return { id: v.id, title: v.option1 || v.title, available: v.available };
            });
            openSheet(variants, product.title);
          });
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectButtons();
      injectGalleryButtons();
    });
  } else {
    injectButtons();
    injectGalleryButtons();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) {
        injectButtons();
        injectGalleryButtons();
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

})();
